import { useDraggable, useDroppable } from '@dnd-kit/core'

import * as React from 'react'

import _get from 'lodash/get'
import _set from 'lodash/set'
import _filter from 'lodash/filter'
import _chain from 'lodash/chain'
import _union from 'lodash/union'

//置く
export const Droppable = (props) => {
  const { id, isDroppable, children, className, ...rest } = props

  const { setNodeRef, isOver } = useDroppable({
    id: 'drop_' + id,
    data: { id, isDroppable }
  })

  return (
    <div ref={setNodeRef} {...rest} className={`${className}`}>
      {children}
      {isOver && <span className={`h-[2px] w-full absolute top-[100%] left-0 bg-green-500`}> </span>}
    </div>
  )
}

//ドラッグ
export const Draggable = (props) => {
  const { type = 'div', id, children, tree, disabled, ...rest } = props

  const { attributes, listeners, setNodeRef, transform, transition } = useDraggable({
    id: 'drag_' + id,
    data: { id },
    disabled
  })

  const transformStyle = {
    transform: `translate(${transform?.x || 0},${transform?.y || 0})`,
    transition
  }

  const style = {
    ...rest.style,
    ...(transform ? transformStyle : {})
    // position: isDragging ? 'absolute' : 'relative'
  }

  return React.createElement(
    type,
    {
      ...rest,
      ...attributes,
      ref: setNodeRef,
      style
    },
    typeof children === 'function' ? children(listeners) : children
  )
}

export class ModifyTree {
  #tree

  constructor(tree) {
    this.#tree = tree
  }

  get tree() {
    return this.#tree
  }

  // ノードを取得
  getNode(id) {
    return _get(this.#tree, id, null)
  }

  // ノードの親を 取得
  getParent(id) {
    return _get(this.#tree, `${id}.Metadata.SuperNode`, null)
  }
  // ノードの子を取得
  getChildren(id) {
    return _get(this.#tree, `${id}.SubNode`, null)
  }
  // ノード」のソート順を取得
  getSortOrder(id) {
    return _get(this.#tree, `${id}.Metadata.DisplayOrder`, null)
  }

  //ソート順を更新
  setSortOrder(id, value) {
    _set(this.#tree, `${id}.Metadata.DisplayOrder`, value)
    return this
  }

  setParent(id, value) {
    _set(this.#tree, `${id}.Metadata.SuperNode`, value)
    return this
  }
  setDepth(id, parent) {
    _set(this.#tree, `${id}.Metadata.Depth`, this.getNode(parent).meta.depth + 1)
    return this
  }

  //ノードに子供追加
  addChild(child, parent) {
    _set(this.#tree, `${parent}.SubNode`, _union(this.getChildren(parent), [child]))
    return this
  }
  //ノードから子を削除
  removeChild(child, parent) {
    const filteredChildList = this.getChildren(parent).filter((e) => e !== child)
    _set(this.#tree, `${parent}.SubNode`, filteredChildList)
    return this
  }
  /**
   *  ソート陣を更新
   * @param {string} id  // ドラッグされる資格
   * @param {string} targetParent  // ドラッグ先の親
   * @param {string} target  // ドラッグを置く資格
   */
  updateSortOrder(id, targetParent, target) {
    if (target === this.getParent(id)) {
      // 最初にソート
      let min = 1
      this.getChildren(target).forEach((e) => {
        const nodeSortOrder = this.getNode(e).Metadata.DisplayOrder
        min = Math.abs(Math.min(min, nodeSortOrder))
        _set(this.#tree, `${e}.Metadata.DisplayOrder`, nodeSortOrder + 1)
      })

      this.setSortOrder(id, min)
    } else {
      // 普通パターン
      const targetSortOrder = this.getSortOrder(target)

      this.setSortOrder(id, targetSortOrder)

      const children = this.getChildren(targetParent)
        .map((e) => this.getNode(e))
        .filter((e) => Number(e?.Metadata?.DisplayOrder) > targetSortOrder)

      children.forEach((e) => {
        _set(e, 'Metadata.DisplayOrder', _get(e, 'Metadata.DisplayOrder', 0) + 1)
      })

      this.setSortOrder(id, targetSortOrder + 1)
    }
  }

  /**
   * 子供リストで一番上の子供をゲット
   * @param {*} nodeId
   */
  getSortedSubNodes(nodeId) {
    return this.getChildren(nodeId).sort((a, b) => this.getSortOrder(a) - this.getSortOrder(b))
  }
}
